<template>
  <div class="paper-box">
    <span>Google Cloud</span>
    <a :href="cardInfo.link" target="_blank">
      <h1>{{ cardInfo.title }}</h1>
    </a>
    <p class="text" v-if="cardInfo.text">{{ cardInfo.text }}</p>
    <div class="download-btn">
      <i class="iconfont iconpdf"></i>
      <a :href="cardInfo.downloadLink" download>
        <span>下载白皮书文档</span>
      </a>
      <i class="iconfont iconjiantou"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ['cardInfo']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.paper-box {
  position: relative;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: space-between;
  padding: 23px 31px;
  width: 552px; min-height: 200px;
  background-color: #fff;
  border: 1px solid $border-color2;
  border-radius: 3px;
  margin-bottom: 18px;
  @include tablet {
    width: calc(50% - 20px);
  }
  >span {
    margin-bottom: 10px;
    line-height: 1;
    color: $font-color3;
    font-size: $fontSize16;
    font-weight: 500;
    font-family: Google Sans;
  }
  >a {
    >h1 {
      margin-bottom: 9px;
      color: $font-color1;
      line-height: 28px;
      font-size: $fontSize20;
      font-weight: 500;
      &:hover {
        color: $primary1;
    }
  }
  }
  >.text {
    color: $font-color2;
    font-size: $fontSize16;
    font-weight: 400;
  }
  >div {
    display: flex;
    align-items: center;
    & .iconpdf {
      font-size: 18px;
      color: $primary1;
    }
    & a {
      & span {
        color: $primary3;
        font-size: $fontSize14;
        font-weight: 500;
        margin: 0 7px;
      }
    }
    .iconjiantou {
      font-size: 10px;
      color: $primary3;
    }
  }
}
.download-btn {
  // position: absolute;
  bottom: 20px;
  left: 31px;
}
</style>
